import { yup } from '@framework/validation/initYup.ts';
import { ComputeExpressionSchema } from '../../../../expressions/compute/validation/ComputeExpressionSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IComputedNumberWidget } from '../IComputedWidget.ts';

export const ComputedNumberConfigSchema = CommonInputWidgetConfigSchema.shape({
  type: yup.string().required().exact(WidgetType.ComputedNumber).label('Tipo'),
  expression: ComputeExpressionSchema.label('Espressione'),
  layout: BaseLayoutSchema.shape({
    hide: yup.boolean().required().default(false).label('Nascondi elemento'),
    removeBorder: yup
      .boolean()
      .required()
      .default(false)
      .label('Rimuovi bordo'),
  }),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IComputedNumberWidget>;
